import { Flex, RadioButtonCheckedIcon, RadioButtonUncheckedIcon, Text } from '@shared/components';

interface ReadonlyBooleanRadioProps {
  value: boolean;
}

export default function ReadonlyBooleanRadio(props: Readonly<ReadonlyBooleanRadioProps>) {
  const { value } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        alignItems: 'start',
        gap: theme.spacing(1),
      })}
    >
      <Flex
        sx={(theme) => ({
          gap: theme.spacing(4),
          alignItems: 'start',
        })}
      >
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(2),
          })}
        >
          {value ? (
            <RadioButtonCheckedIcon sx={(theme) => ({ color: theme.palette.grey[500] })} />
          ) : (
            <RadioButtonUncheckedIcon sx={(theme) => ({ color: theme.palette.grey[400] })} />
          )}
          <Text>มี</Text>
        </Flex>
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(2),
          })}
        >
          {!value ? (
            <RadioButtonCheckedIcon sx={(theme) => ({ color: theme.palette.grey[500] })} />
          ) : (
            <RadioButtonUncheckedIcon sx={(theme) => ({ color: theme.palette.grey[400] })} />
          )}
          <Text>ไม่มี</Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
